import type { TMilliseconds } from '@Anarchy/Engine/Math/Types';

export const MILLISECOND: TMilliseconds = 1 as TMilliseconds;
export const SECOND: TMilliseconds = 1000 as TMilliseconds;
export const MINUTE: TMilliseconds = 60000 as TMilliseconds;
export const HOUR: TMilliseconds = 3600000 as TMilliseconds;
